import { render, staticRenderFns } from "./ResidentDetail.vue?vue&type=template&id=339a8a77&scoped=true"
import script from "./ResidentDetail.vue?vue&type=script&lang=js"
export * from "./ResidentDetail.vue?vue&type=script&lang=js"
import style0 from "./ResidentDetail.vue?vue&type=style&index=0&id=339a8a77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339a8a77",
  null
  
)

export default component.exports